export function readContainerPreference(chatId: string | null, fallback: boolean): boolean {
  try {
    if (!chatId) return fallback
    const stored = localStorage.getItem(`chat-container-${chatId}`)
    return stored === null ? fallback : stored === 'true'
  } catch {
    return fallback
  }
}
